<div class="d-flex flex-wrap align-items-center" mat-dialog-title>
  <div class="d-flex align-items-center">
    <nb-icon 
      [icon]="activityMeta?.type === 'Call' || activityMeta?.type === 'CFCall' ? 'phone-call-outline' : 
              (activityMeta?.type === 'Email' ? 'email-outline' : 'activity-outline')" 
      class="me-2 mr-2"
      [ngClass]="{'call-icon': activityMeta?.type === 'Call' || activityMeta?.type === 'CFCall', 
                  'email-icon': activityMeta?.type === 'Email',
                  'other-icon': activityMeta?.type === 'Other'}">
    </nb-icon>
    <h5 class="mb-0">
      {{ activityMeta?.type === 'Call' || activityMeta?.type === 'CFCall' ? 'Call Information' : 
         (activityMeta?.type === 'Email' ? (activityMeta?.action === 'Send' ? 'Email Sent' : (activityMeta?.action === 'ReplyDetail' ? 'Email Replied' : 'Email Information')) : 
         'Activity Information') }}
    </h5>
  </div>
  <button mat-icon-button aria-label="Close the dialog" (click)="closeDialog()" class="ml-auto">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <!-- Call Information -->
    <div *ngIf="activityMeta?.type === 'Call' || activityMeta?.type === 'CFCall'" class="log-section">
      
      <div class="info-grid">
        <div class="info-item" *ngIf="activityMeta?.caller">
          <label>Caller:</label>
          <span class="value">{{ activityMeta?.caller }}</span>
        </div>

        <!-- CFCall specific: User -->
        <div class="info-item" *ngIf="activityMeta?.user">
          <label>User:</label>
          <span class="value">{{ activityMeta?.user }}</span>
        </div>

        <!-- CFCall specific: Call result badge (generic) -->
        <div class="info-item" *ngIf="activityMeta?.callEvent">
          <label>Status:</label>
          <span class="value badge" [ngClass]="getBadgeClass(activityMeta?.callEvent)">{{ activityMeta?.callEvent }}</span>
        </div>

        <!-- CFCall specific: Recipient (Outbound) -->
        <div class="info-item" *ngIf="activityMeta?.recipient">
          <label>Recipient:</label>
          <span class="value">{{ activityMeta?.recipient }}</span>
        </div>

        <div class="info-item" *ngIf="activityMeta?.phone">
          <label>Phone number:</label>
          <span class="value">{{ activityMeta?.phone | phoneFormat }}</span>
        </div>

        <div class="info-item" *ngIf="activityMeta?.duration">
          <label>Duration:</label>
          <span class="value duration">
            <nb-icon icon="clock-outline"></nb-icon>
            {{ activityMeta?.duration }}
          </span>
        </div>

        <!-- CFCall specific: Event -->
        <div class="info-item" *ngIf="activityMeta?.event">
          <label>Event:</label>
          <span class="value">{{ activityMeta?.event }}</span>
        </div>

        <div class="info-item" *ngIf="activityMeta?.time">
          <label>Time:</label>
          <span class="value">{{ activityMeta?.time | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
        
        <div class="info-item full-width" *ngIf="activityMeta?.description">
          <label>{{activityMeta?.type?.toLowerCase() == 'cfcall' ? 'Summary:' : 'Description:'}}</label>
          <div class="value description-value">{{ activityMeta?.description }}</div>
        </div>


      </div>
    </div>

    <!-- Email Information -->
    <div *ngIf="activityMeta?.type === 'Email'" class="log-section">
      
      <div class="info-grid">
        <div class="info-item full-width" *ngIf="activityMeta?.title">
          <label>Subject:</label>
          <span class="value title-value">{{ activityMeta?.title }}</span>
        </div>
        
        <div class="info-item" *ngIf="activityMeta?.senderDisplay || activityMeta?.recipient">
          <label>Sender:</label>
          <span class="value email-value">
            <nb-icon icon="person-outline"></nb-icon>
            {{ activityMeta?.action === 'ReplyDetail' ? activityMeta?.recipient : activityMeta?.senderDisplay }}
          </span>
        </div>
        
        <div class="info-item" *ngIf="activityMeta?.recipient || activityMeta?.senderDisplay">
          <label>Recipient:</label>
          <span class="value email-value">
            <nb-icon icon="person-outline"></nb-icon>
            {{ activityMeta?.action === 'ReplyDetail' ? activityMeta?.senderDisplay : activityMeta?.recipient }}
          </span>
        </div>

        <div class="info-item" *ngIf="activityMeta?.action">
          <label>Action:</label>
          <span class="value badge" [ngClass]="activityMeta?.action === 'Send' ? 'badge-info' : 'badge-success'">
            {{ {Send: 'Sent', ReplyDetail: 'Replied'}[activityMeta?.action] }}
          </span>
        </div>

        <div class="info-item" *ngIf="activityMeta?.time">
          <label>Time:</label>
          <span class="value">{{ activityMeta?.time | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
        
        <div class="info-item full-width" *ngIf="activityMeta?.description">
          <label>Description:</label>
          <div class="value description-value">{{ activityMeta?.description }}</div>
        </div>

        <div class="info-item full-width" *ngIf="activityMeta?.body">
          <label>Content:</label>
          <div class="value body-value" [innerHTML]="activityMeta?.body"></div>
        </div>
      </div>
    </div>

    <!-- Other Information -->
    <div *ngIf="activityMeta?.type === 'Other'" class="log-section">
      <div class="info-grid">
        <div class="info-item" *ngIf="activityMeta?.action">
          <label>Action:</label>
          <span class="value">{{ activityMeta?.action }}</span>
        </div>

        <div class="info-item" *ngIf="activityMeta?.time">
          <label>Time:</label>
          <span class="value">{{ activityMeta?.time | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
        
        <div class="info-item full-width" *ngIf="activityMeta?.description">
          <label>Description:</label>
          <div class="value description-value">{{ activityMeta?.description }}</div>
        </div>
      </div>
    </div>
</mat-dialog-content>
